export default {
      id: "i-vk-circle-dark-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "img/sprite.svg#i-vk-circle-dark",
      toString: function () {
        return this.url;
      }
    }